import React from 'react';
import {
    Area, Title, RedStripe, Providers, Provider0Icon, Provider1Icon, Provider2Icon,
    Provider3Icon, Provider4Icon, Provider5Icon, CTA,
} from './Providers.style';

const Provider = ({ setFormActive, content }) => {
    const { segmentTitle, cta } = content;

    return <Area>
        <Title>
            <RedStripe />
            {!!segmentTitle && segmentTitle.text}
        </Title>
        <Providers>
            <Provider0Icon />
            <Provider1Icon />
            <Provider2Icon />

            <Provider3Icon />
            <Provider4Icon />
            <Provider5Icon />
        </Providers>
        <CTA onClick={() => setFormActive(true)}>{!!cta && cta.text}</CTA>
    </Area>;
};

export default Provider;